<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PREGLED ZAHTJEVA ZA SIROVINE</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <dx-button
          class="btn_trazi"
          [disabled]="disableGumb"
          stylingMode="contained"
          text="Prikaži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>
    <div class="customTable dnevniPlan">
      <dx-data-grid
        id="tablicaZahtjeva"
        [dataSource]="zahtjevi"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="idzahtjevsirovinezag"
        [showBorders]="false"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onRowClick)="onRowClick($event)">

        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Pregled zahtjeva</h2>
            <p class="mt-0">Kliknite na zahtjev za prikaz detalja</p>
          </div>
        </div>

        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'">
        </dxo-scrolling>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži...">
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true">
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxi-column
          dataField="idzahtjevsirovinezag"
          caption="Broj zahtjeva"
          [width]="150"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="vrsta"
          caption="Vrsta zahtjeva"
          [width]="150">
        </dxi-column>
        <dxi-column
          dataField="vrijemepodnosenjazahtjeva"
          dataType="datetime"
          format="dd.MM.YYYY. HH:mm:ss"
          caption="Datum i vrijeme"
          [width]="170"
          alignment="left">
        </dxi-column>
        <dxi-column
          dataField="smjena"
          caption="Smjena"
          [width]="120"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="ar_naziv"
          caption="Proizvod"
          [minWidth]="250"
          alignment="left">
        </dxi-column>
        <dxi-column
          dataField="li_naziv"
          caption="Linija"
          [minWidth]="200">
        </dxi-column>
        <dxi-column
          dataField="nl_broj"
          caption="Radni nalog"
          [minWidth]="100"
          alignment="left">
        </dxi-column>
        <dxi-column
          cellTemplate="kreiranaIzdatnica"
          caption="Izdatnica kreirana"
          [width]="130"
          alignment="center">
          <div *dxTemplate="let data of 'kreiranaIzdatnica'">
            <i *ngIf="!data.data.zsz_status" class="dx-icon-close"></i>
            <i *ngIf="data.data.zsz_status" class="dx-icon-check"></i>
          </div>
        </dxi-column>
        <dxi-column
          dataField="zahtjevpredao"
          caption="Zahtjev predao">
        </dxi-column>
        <dxi-column cellTemplate="izdatnica" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'izdatnica'">
            <dx-button text="Izdatnica" (onClick)="kreirajIzdatnicu(data)"></dx-button>
          </div>
        </dxi-column>
        <dxi-column cellTemplate="uredjivanje" [minWidth]="60" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'uredjivanje'">
            <dx-button icon="trash" hint="Obriši" (click)="obrisiZahtjevPovrat(data)"></dx-button>
          </div>
        </dxi-column>
        <dxo-master-detail
          [enabled]="false"
          template="detail">
        </dxo-master-detail>
        <div *dxTemplate="let data of 'detail'">
          <p *ngIf="sirovine.length === 0">Dohvaćanje podataka...</p>
          <div *ngIf="sirovine.length > 0">
            <div class="sirovine">
              <!--problem što se pri dnu tablice klikom na red ne prikaže cijela tree lista (mora se dva puta kliknuti onda bude dobro) -->
              <!-- dx-tree-list  -->
              <dx-data-grid
                [dataSource]="sirovine"
                [wordWrapEnabled]="true"
                keyExpr="idzahtjevsirovinastavke"
                [showBorders]="true"
                (onEditingStart)="onEditingStart($event)"
                (onRowUpdated)="onRowUpdated($event)"
                (onRowRemoved)="onRowRemoved($event)">
                
                <dxo-editing mode="popup" 
                  [allowUpdating]="true"
                  [allowDeleting]="true">

                  <dxo-popup                        
                    [onShowing]="onShowing"
                    title= ""
                    [showTitle]="true"
                    [width]="500"
                    [height]="'auto'">
                  </dxo-popup> 

                  <dxo-form >
                    <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
                      <dxi-item dataField="ar_sifra"></dxi-item>
                      <dxi-item dataField="ar_naziv"></dxi-item>
                      <dxi-item dataField="zss_kolicina_edit"></dxi-item>
                      <dxi-item dataField="jedinicamjere_JM_SIFRA"></dxi-item>
                      <dxi-item dataField="zss_ar_lot"></dxi-item>
                    </dxi-item>
                  </dxo-form>

                </dxo-editing>

                <dxi-column
                  dataField="ar_sifra"
                  caption="Šifra"
                  [width]="200"
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column
                  dataField="ar_naziv"
                  caption="Sirovina"
                  [width]="400"
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column
                  dataField="zss_kolicina_edit"
                  caption="Količina"
                  [width]="100">
                </dxi-column>
                <dxi-column
                  dataField="jedinicamjere_JM_SIFRA"
                  caption="Jed.mj."
                  [width]="80"
                  [allowEditing]="false">
                </dxi-column>
                <!-- u tablici prikazujem jedno a u formi za dodavanje/uredivanje drugo -->
                <!-- zato sto sviLotovi_artikla ovise tj. dohvacaju se i pune kad odaberemo artikl -->
                <dxi-column
                  dataField="zss_ar_lot"
                  caption="LOT"
                  [width]="300" 
                  [visible]="false"
                  [formItem]="{ visible: true }">
                  <dxo-lookup
                    [dataSource]="sviLotovi_artikla"
                    valueExpr="ar_lot"
                    displayExpr="ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno">
                  </dxo-lookup>
                </dxi-column>
                <dxi-column
                  dataField="zss_ar_lot"
                  caption="LOT"
                  [width]="100"
                  [formItem]="{ visible: false }">
                </dxi-column>
              </dx-data-grid>
            </div>
          </div>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
